// extracted by mini-css-extract-plugin
export default {"PopisSluzieb":"PopisSluzieb_PopisSluzieb__mjaEr","content":"PopisSluzieb_content__BoLLs"};